class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();
        if (typeof initUpsellSlider === "function") { 
          initUpsellSlider()
        }
        

      
    if($("cart-drawer-items").hasClass("is-empty")){
      if($("#product-grid_empty_cart").hasClass("slick-initialized")){
        $("#product-grid_empty_cart").slick("resize");     
        $('.cart-drawer__collection').slick("resize"); 
      }else{        
        $("#product-grid_empty_cart").slick({
          dots: true, // Afficher les points
          arrows: true, // Afficher les flèches
          slidesToShow: 1, // Afficher un seul élément par diapositive
          slidesToScroll: 1, // Faire défiler un seul élément à la fois
          prevArrow:"<button type='button' class='slick-prev pull-left'><svg xmlns='http://www.w3.org/2000/svg' width='7' height='14' viewBox='0 0 7 14' fill='none'> <path d='M0.701829 6.90389C0.701829 7.08352 0.761734 7.25317 0.891528 7.39287L5.69391 12.8814C5.96348 13.2008 6.43273 13.2307 6.74224 12.9513C7.05175 12.6719 7.09169 12.2128 6.81213 11.9035L2.44906 6.90389L6.81213 1.90431C7.0817 1.59495 7.05175 1.11595 6.74224 0.846514C6.43273 0.577075 5.95349 0.607013 5.68392 0.916368L0.881544 6.41491C0.761734 6.55462 0.691845 6.73425 0.691845 6.90389H0.701829Z' fill='black'/> </svg></button>",
          nextArrow:"<button type='button' class='slick-next pull-right'><svg xmlns='http://www.w3.org/2000/svg' width='7' height='14' viewBox='0 0 7 14' fill='none'> <path d='M6.29817 6.90389C6.29817 7.08352 6.23827 7.25317 6.10847 7.39287L1.30609 12.8814C1.03652 13.2008 0.567267 13.2307 0.257758 12.9513C-0.0517502 12.6719 -0.0916868 12.2128 0.187869 11.9035L4.55094 6.90389L0.187869 1.90431C-0.0817027 1.59495 -0.0517502 1.11595 0.257758 0.846514C0.567267 0.577075 1.04651 0.607013 1.31608 0.916368L6.11846 6.41491C6.23827 6.55462 6.30816 6.73425 6.30816 6.90389H6.29817Z' fill='black'/> </svg></button>"
        });
        $('.cart-drawer__collection').slick({
          slidesToShow: 2.5, // Affiche 2 éléments complets et la moitié du 3ème
          slidesToScroll: 1, 
          dots:false,
          infinite:false,
          arrows:false,
          centerMode: false // Désactive le mode centré
        });
        $('.cart-drawer__collection').slick("resize"); 
      }
    }
      $("#product_reviews_cart").slick({
        dots: true,      
        arrows: true, 
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1 ,
      prevArrow:"<button type='button' class='slick-prev pull-left'><svg xmlns='http://www.w3.org/2000/svg' width='12' height='15' viewBox='0 0 7 14' fill='none'> <path d='M0.701829 6.90389C0.701829 7.08352 0.761734 7.25317 0.891528 7.39287L5.69391 12.8814C5.96348 13.2008 6.43273 13.2307 6.74224 12.9513C7.05175 12.6719 7.09169 12.2128 6.81213 11.9035L2.44906 6.90389L6.81213 1.90431C7.0817 1.59495 7.05175 1.11595 6.74224 0.846514C6.43273 0.577075 5.95349 0.607013 5.68392 0.916368L0.881544 6.41491C0.761734 6.55462 0.691845 6.73425 0.691845 6.90389H0.701829Z' fill='black'/> </svg></button>",
      nextArrow:"<button type='button' class='slick-next pull-right'><svg xmlns='http://www.w3.org/2000/svg' width='12' height='15' viewBox='0 0 7 14' fill='none'> <path d='M6.29817 6.90389C6.29817 7.08352 6.23827 7.25317 6.10847 7.39287L1.30609 12.8814C1.03652 13.2008 0.567267 13.2307 0.257758 12.9513C-0.0517502 12.6719 -0.0916868 12.2128 0.187869 11.9035L4.55094 6.90389L0.187869 1.90431C-0.0817027 1.59495 -0.0517502 1.11595 0.257758 0.846514C0.567267 0.577075 1.04651 0.607013 1.31608 0.916368L6.11846 6.41491C6.23827 6.55462 6.30816 6.73425 6.30816 6.90389H6.29817Z' fill='black'/> </svg></button>"
        
      });
        $("slider-component#Slider-cart").slick({
          dots: true,      
          arrows: false,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000   
        });
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
    
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  });
};
